<i class="fa {{icon}}"></i>
<span class="text">
<ng-content></ng-content>
</span>
